<template>
    <v-dialog v-model="showDialog" persistent width="400">
        <v-card>
            <v-card-title>
                <div>
                    <h2 v-show="id" class="headline"> Projeto #{{id}}</h2>
                    <h2 v-show="!id" class="headline"> Novo Projeto</h2>
                </div>
                <v-spacer></v-spacer>
                <v-btn fab small text @click="doHideDialog">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-card-title>
            <v-progress-linear
              indeterminate
              v-show="isLoading"
              color="green"
            ></v-progress-linear>
            <v-layout column>
                <v-layout :column="isSmallScreen">
                    <v-flex xs12 align-end flexbox>
                        <v-form class="pl-5 pr-5" ref="form" v-model="valid" lazy-validation>
                            <v-layout class="pl-4" row wrap>
                                <v-text-field
                                    v-model="formData.nome"
                                    :readonly="!formAllowEdit"
                                    label="Nome"
                                ></v-text-field>
                            </v-layout>
                            <v-layout class="pl-4" row wrap>
                                <v-switch
                                    v-model="formData.arquivado"
                                    color="success"
                                    :readonly="!formAllowEdit"
                                    label="Arquivado"
                                ></v-switch>
                            </v-layout>
                        </v-form>
                    </v-flex>
                </v-layout>
            </v-layout>
            <v-card-title class="pb-5">
                <v-btn text color="green" v-if="!formAllowEdit" @click="formAllowEdit = !formAllowEdit">
                    <v-icon left>edit</v-icon>Habilitar edição
                </v-btn>
                <v-btn
                    color="success"
                    v-if="formAllowEdit"
                    :disabled="!valid"
                    @click="submit"
                >
                    Salvar
                </v-btn>
                <v-spacer></v-spacer>
                <v-menu open-on-click bottom offset-y v-if="!formAllowEdit">
                    <template v-slot:activator="{ on }">
                        <v-btn text v-on="on">
                            <v-icon >more_vert</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item @click="doRemove(recordId)">
                            <v-list-item-action>
                                <v-icon>delete</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Remover</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>
        </v-card>
    </v-dialog>
</template>

<style>
.inputPrice input[type='number'] {
    -moz-appearance:textfield;
}
.inputPrice input::-webkit-outer-spin-button,
.inputPrice input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
</style>

<script>

import Utils from '@/utils/Utils.js';
import { EventBus } from '@/EventBus.js';
import { Store } from '@/utils/Store.js';
import moment from 'moment';

export default {
    props: ['id', 'cliente', 'showDialog'],
    computed: {
        isSmallScreen() {
            return this.$vuetify.breakpoint.smAndDown;
        }
    },
    data: () => ({
        recordId: null,
        isLoading: false,
        formAllowEdit: false,
        formData: {},
        valid: true
    }),
    methods: {
        doHideDialog() {
            EventBus.$emit('hideProjetoForm');
            this.recordId = null;
            this.isLoading = false;
            this.formAllowEdit = false;
            this.formData = {};
        },
        loadData() {
            this.formAllowEdit = false;
            this.recordId = this.id;
            const self = this;
            this.isLoading = true;
            Utils.apiAjax({
                url: '/projetos/Projetos/' + this.recordId,
                success: (response, rawResponse) => {
                    self.isLoading = false;
                    const auxData = response.data[0];

                    self.formData = auxData;
                },
                failure: (response, rawResponse) => {
                    self.isLoading = false;
                    return true;
                }
            });
        },
        doRemove(id) {
            const self = this;
            EventBus.$emit('showConfirmDialog', {
                title: 'Atenção',
                text: 'Deseja apagar o projeto?',
                action: () => {
                    self.isLoading = true;
                    Utils.apiAjax({
                        url: '/projetos/Projetos/' + id,
                        method: 'delete',
                        success: (response, rawResponse) => {
                            self.isLoading = false;
                            EventBus.$emit('showPopUp', {
                                text: 'Projeto removido com sucesso'
                            });
                            self.doHideDialog();
                        },
                        failure: (response, rawResponse) => {
                            self.isLoading = false;
                            const errorMsg = (response.msg !== '' && response.msg !== undefined) ? response.msg : 'Erro ao remover registro';
                            EventBus.$emit('showErrorDialog', errorMsg);
                            return true;
                        }
                    });
                }
            });
        },
        submit() {
            let self = this;
            this.isLoading = true;

            let params = this.formData;

            delete params.cliente;
            if (this.cliente) {
                params.cliente = this.cliente;
            }

            if (this.recordId) {
                let id = this.recordId;

                Utils.apiAjax({
                    url: '/projetos/Projetos/' + id,
                    method: 'put',
                    params,
                    success: () => {
                        EventBus.$emit('showPopUp', {
                            text: 'Projeto alterado com sucesso'
                        });
                        self.doHideDialog();
                    },
                    failure: () => {
                        self.isLoading = false;
                        EventBus.$emit('showErrorDialog', 'Erro ao atualizar registro');
                        return true;
                    }
                });
            } else {
                Utils.apiAjax({
                    url: '/projetos/Projetos',
                    method: 'post',
                    params,
                    success: () => {
                        EventBus.$emit('showPopUp', {
                            text: 'Projeto cadastrado com sucesso'
                        });
                        self.doHideDialog();
                    },
                    failure: () => {
                        self.isLoading = false;
                        EventBus.$emit('showErrorDialog', 'Erro ao inserir registro');
                        return true;
                    }
                });
            }
        }
    },
    watch: {
        'showDialog': function (val) {
            if (!this.id) {
                this.formAllowEdit = true;
            }
            console.log(this.cliente);
            if (this.showDialog && this.id) {
                this.loadData();
            }
        }
    }
}
</script>